var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Página não encontrada.")]),_c('router-link',{staticClass:"home",attrs:{"to":"/"}},[_vm._v("Voltar para Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }